// @vendors
import { useTranslation } from 'react-i18next';

const MessagesUser = () => {
    const { t } = useTranslation();

    return (
        <div className='w-full h-screen flex items-center justify-center'>
            <p className='flex text-[30px] text-gray-400 dark:text-white text-center'>
                {t("professional.messages.message")}
            </p>
        </div>
    )
}

export default MessagesUser